import * as S from "../../Style/Page/Fork.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitleFork.js";
import HatPageTopLine from "../../Component/ForkPageTopLine.js";
const Factory1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/36. 베트남법인.d3268e553ae52f49cf63.jpg`;
const SaleImg1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/37. 베트남법인 부품1.03958f0e3fe0db4444cd.png`;
const SaleImg2 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/38. 베트남법인 부품2.8c88e298a650162c32f3.png`;
const SaleImg3 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/39. 베트남법인 부품3.a64082b27f27515c5f10.png`;
const SaleImg4 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/40. 베트남법인 부품4.e902e3429b5b909d8daf.png`;
const SaleImg5 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/41. 베트남법인 부품5.628fdaa2782664fb6e94.png`;
const ForkHeadOffice10 = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"지게차사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/ForkLiftBusiness/Introduce">
                <div className="kor">지게차사업</div>
                <div className="eng">Fork Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"156px"}>
            <S.NavItem>
              <Link to="/ForkLiftBusiness/HeadOfficeUsa">
                <div className="kor">지역별법인</div>
                <div className="eng">Corporation by region</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">클라크</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOfficeUsa">
                  <div className="kor">지역별법인</div>
                  <div className="eng">Corporation by region</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/History">
                  <div className="kor">주요사업이력</div>
                  <div className="eng">Major business history</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"830px"}>
            <S.NavItem>
              <Link to="/ForkLiftBusiness/HeadOffice10">
                <div className="kor">베트남 2공장</div>
                <div className="eng">Vietnam Company2</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOfficeUsa">
                  <div className="kor">클라크 미국본사</div>
                  <div className="eng">USA HQ</div>
                </Link>
              </S.NavItem>
<S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOfficeMexico">
                  <div className="kor">멕시코 법인</div>
                  <div className="eng">Mexico Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice2">
                  <div className="kor">브라질 법인</div>
                  <div className="eng">Brasil Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice3">
                  <div className="kor">코스타리카 법인</div>
                  <div className="eng">Costa-Rica Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice4">
                  <div className="kor">독일 법인</div>
                  <div className="eng">Germany Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice5">
                  <div className="kor">프랑스 법인</div>
                  <div className="eng">France Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice6">
                  <div className="kor">호주 법인</div>
                  <div className="eng">Australia Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice7">
                  <div className="kor">싱가폴 법인</div>
                  <div className="eng">Singapore Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                                            <Link to="/ForkLiftBusiness/HeadOfficeVnHq">
                                              <div className="kor">베트남 판매법인</div>
                                              <div className="eng">Vietnam Sales Company</div>
                                            </Link>
                                          </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice8">
                  <div className="kor">한국 법인 (부천)</div>
                  <div className="eng">Korea HQ (Bucheon)</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice9">
                  <div className="kor">베트남 1공장</div>
                  <div className="eng">Vietnam Company1</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice10">
                  <div className="kor">베트남 2공장</div>
                  <div className="eng">Vietnam Company2</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice11">
                  <div className="kor">중국법인</div>
                  <div className="eng">China Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                                                                                      <Link to="/ForkLiftBusiness/HeadOfficeIdnesia">
                                                                                        <div className="kor">인도네시아 법인</div>
                                                                                        <div className="eng">Indonesia Company</div>
                                                                                      </Link>
                                                                                    </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice12">
                  <div className="kor">한국 법인 (창원)</div>
                  <div className="eng">Korea Company (Changwon) </div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                                                                                      <Link to="/ForkLiftBusiness/HeadOfficeRnd">
                                                                                        <div className="kor">글로벌 연구소</div>
                                                                                        <div className="eng">Global R&D Center</div>
                                                                                      </Link>
                                                                                    </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <PageTitle titleko={"베트남 법인"} titleeng={"CLARK Vietnam Company"} />
            <div className="page-text">
              <h2>CLARK-BOOKOOK Vietnam Co., Ltd. / CBVN</h2>
            </div>

            <S.ImgHolderFullsize>
              <img src={Factory1} className="holder-img plus" alt="" />
              <div className="holder-name">
                <div className="kor">베트남 법인</div>
                <div className="eng">CLARK-BOOKOOK Vietnam Co., Ltd. / CBVN</div>
              </div>
            </S.ImgHolderFullsize>

            <PageTitle titleko={"주요 판매 제품"} titleeng={"Major Production Products"} />
            <S.SaleItemList>
              <S.SaleItem>
                <img src={SaleImg1} alt="" />
              </S.SaleItem>
              <S.SaleItem>
                <img src={SaleImg2} alt="" />
              </S.SaleItem>
              <S.SaleItem>
                <img src={SaleImg3} alt="" />
              </S.SaleItem>
              <S.SaleItem>
                <img src={SaleImg4} alt="" />
              </S.SaleItem>
              <S.SaleItem>
                <img src={SaleImg5} alt="" />
              </S.SaleItem>
            </S.SaleItemList>
            <PageTitle titleko={"주요 이력"} titleeng={"Major History"} />
            <div className="page-text">
              <div className="page-text-flex">
                <div className="page-text-area">
                  <div className="page-text-title">
                    <div className="kor">CLARK-BOOKOOK Vietnam Co., Ltd. 법인개요<br /></div>
                    <div className="eng">Company Profile of CLARK-BOOKOOK Vietnam Co., Ltd.</div>
                  </div>
                  <div className="kor">설립일: 2020년 <br /></div>
                  <div className="eng">Establishment : 2020 <br /></div>
                </div>
              </div>
              <div className="kor">
                ※ 지게차 주요 제관품에 대한 안정적인 공급을 위해 부품 합자법인
                설립
                <br />※ CMHVN 포함 클라크 글로벌 공장에 관련 부품 공급중
              </div>
              <div className="eng">
                ※ Establishment of a parts JV company for stable supply of major forklift products <br />
                ※ Parts supply to CLARK Global factories including CMHVN
              </div>
            </div>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default ForkHeadOffice10;
